import { QueryClient } from "@tanstack/react-query";

// Canonical module-level QueryClient singleton. Non-component modules (e.g.
// the thread-list adapter) import it directly for fetchQuery / getQueryData.
// Component trees continue to read it from QueryClientProvider via
// useQueryClient(). Options are copied verbatim from the previous inline
// construction at `app/src/main.tsx` — both `retry: false` and
// `refetchOnWindowFocus: "always"` are load-bearing for our error UX and
// multi-tab refresh behavior. Do not paraphrase.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: "always",
        },
    },
});
